import { connect } from "react-redux";
import { MedicoViewProps, mapDispatchToMedicoProps, mapStateToMedicoProps } from "../medico.controller";
import { Medico } from "../medico.model";
import { Select as ViewList } from "../../../components/select";
import { Box, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { MedicoCadastro } from "./medico.cad";
 
export const columnsMedico: GridColDef[] = [
    { field: 'nome', headerName: 'Profissional', flex: 1 },
    { field: 'especialidade', headerName: 'Especialidade', flex: 1 },
]

function MedicoList(props: MedicoViewProps) {
    const { medicoActions,medicoState } = props
    const { error, loadingRows, msg, row, rows, showAlert, showDialogExluir, status,showCadModal,changeList } = medicoState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue,setShowCadModal } = medicoActions
    console.log("MedicoList props ",props)

    useEffect(()=>{
        if(rows.length === 0)
            read()
    },[])

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    const handleAlterar = (row: any) => {
        console.log("chamou handleAlterar")
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        console.log("chamou handleCloseCadastro")
        setShowCadModal(false)
    }

    function Cadastro() {
        return MedicoCadastro({
            ...props,
            handleCloseView: handleCloseCadastro
        }).renderModal({
            handleClose: handleCloseCadastro,
            show: showCadModal,
            heigth: "auto",
            width:"sm"
        })
    }

    const List = ()=>{
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={"Profissionais Cadastrados"}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"nome"}
                columns={columnsMedico}
                rows={rows}
                loading={loadingRows}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick:()=>read()
                }}
                ListItemTextPrimary={(row: Medico) => <Typography component={"span"}>{row.nome}</Typography>}
            />
        )
    }

    return (
        <div className="modulo">
            <Cadastro />
            <List />
        </div>
    )

}

export default connect(mapStateToMedicoProps,mapDispatchToMedicoProps)(MedicoList);
